/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { observer } from 'mobx-react';

import Notification from './Notification';
import { notificationStore } from './';
import * as Styled from './Notifications.styled';

function Notifications() {
  const { notifications } = notificationStore;

  if (notifications.length) {
    return (
      <Styled.Notifications>
        {notifications.map((notification) => (
          <Notification
            key={notification.id}
            id={notification.id}
            isClosing={notification.__close}
            options={notification.options}
            {...notification.props}
          />
        ))}
      </Styled.Notifications>
    );
  }

  return null;
}

export default observer(Notifications);
